<template>
  <div class="container">
    <!-- Row 1 -->
    <div class="place_row">
      <div class="img_container flex-2">
        <img src="../assets/image/place_01.svg" alt="Dental Lab Work" />
      </div>
      <div class="img_container flex-1">
        <img src="../assets/image/place_02.svg" alt="Reception" />
      </div>
    </div>
    <!-- Row 2 -->
    <div class="place_row">
      <div class="img_container flex-1">
        <img src="../assets/image/place_03.svg" alt="Digital Workflow" />
      </div>
      <div class="img_container flex-2">
        <img src="../assets/image/place_04.svg" alt="Microscope Work" />
      </div>
    </div>
    <!-- Row 3 -->
    <div class="place_row">
      <div class="full_img_container">
        <img src="../assets/image/place_05.svg" alt="Lab Overview" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
/* 전체 컨테이너 스타일 */
.container {
  height: 100%;
  background-color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 32px;
  gap: 8px;
  box-sizing: border-box;
  overflow-x: hidden;
}

/* 행 스타일 */
.place_row {
  display: flex;
  width: 100%;
  gap: 8px;
  justify-content: space-between;
}

/* 이미지 컨테이너 공통 */
.img_container,
.full_img_container {
  height: 146px;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.full_img_container {
  width: 100%;
}

.flex-1 {
  flex: 1.3;
}

.flex-2 {
  flex: 2;
}

/* 공통 이미지 스타일 */
.img_container > img,
.full_img_container > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
